import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SharedOrderService {
    private orderSource = new BehaviorSubject<any>(null);
    currentOrder = this.orderSource.asObservable();

    constructor() { }

    setOrder(order: any) {
        this.orderSource.next(order);
    }
}
